import {createSlice} from '@reduxjs/toolkit';

const initialState = {
  countryCode: sessionStorage.getItem('countryCode') || '' // Get countryCode from sessionStorage
};

const countryCodeSlice = createSlice({
  name: 'countryCode',
  initialState,
  reducers: {
    setCountryCode(state, action) {
      state.countryCode = action.payload;
      sessionStorage.setItem('countryCode', state.countryCode); // Save countryCode to sessionStorage
    }
  }
});

export const {setCountryCode} = countryCodeSlice.actions;

export const selectCountryCode = (state) => state.countryCode?.countryCode; // Selector for countryCode

export default countryCodeSlice.reducer;
